// @flow
import React, { memo, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import SrollByDrag from 'app/common/components/ScrollByDrag';
import { campSelector } from 'app/dataProviders/campSelector';

import enhance from './enhanceStudentsSelector';
import StudentItem from './StudentItem';
import styles from './StudentsSelector.scss';


type Props = {
  students: Array<Object>,
  style?: Object,
  camp?: boolean,
}

const StudentsSelector = ({ students, style, camp }: Props) => {
  useEffect(() => {
    campSelector.initFromStudents(students);
  }, []);

  return (
    <SrollByDrag refPath={['view']}>
      {reference => (
        <Scrollbars
          ref={reference}
          className={styles.root}
          style={{ width: 800, height: 110, ...style }}
        >
          <div className={styles.items}>
            {students.map(student => (
              <StudentItem key={student.id} camp={camp} {...student} />
            ))}
          </div>
        </Scrollbars>)}
    </SrollByDrag>
  );
};

export default memo(enhance(StudentsSelector));
